import { FunctionalComponentOptions } from 'vue/types';
import l10n from '@/transformers/l10n';

type Props = {
   tk: string,
   params: {},
   count?: number,
} & Record<string, any>;


const L10n: FunctionalComponentOptions<Props> = {
   functional: true,
   name: 'l10n',
   render(h, ctx) {
      const { props } = ctx;
      const { tk, params, count } = props;
      return  (ctx as any)._v(l10n(tk, params, count));
   },
};

export default L10n;
